/* © Facilogi. See LICENSE file for full copyright & licensing details. */

import { $t } from "App/IOC";
import { Column, CustomError } from "App/Models";
import Columns from "App/UseCases/Columns";

let sort: Column;
let columns: Column[] = [];

function GetDefaultSort(): Column {
    /* To avoid an issue with $t being empty because it has yet to be injected to Ioc because if
       we put this instantiation at the module level here, it will get executed during
       node module importation step, which is before we inject the actual $t() implementation into
       our Ioc (Through Web/Main.ts), so we wrap it in a funtion. */
    if( sort === undefined )
        sort = new Column( "id", $t( "ADS_PUBLICATION_columnName" ));

    return sort;
}

function getDefault(): Column[] {
    if( columns.length === 0 )
        columns = [
            Column.Static(
                "image", $t( "ADS_PUBLICATION_columnImage" ), "thumbnail"
            ),
            new Column( "Id", $t( "ADS_PUBLICATION_columnId" ) ),
            new Column( "name", $t( "ADS_PUBLICATION_columnName" ) ),
            Column.Static( "gateway_type", $t( "ADS_PUBLICATION_columnType" ) ),
            Column.Static( "description", $t( "ADS_PUBLICATION_columnDescription" ) ),
            Column.Static( "groups", $t( "ADS_PUBLICATION_columnGroups" ) ),
            Column.Static( "serializer", $t( "ADS_PUBLICATION_columnSerializer" ) )
        ];

    return columns;
}

async function Get(): Promise<[ Column[], CustomError | undefined ]> {
    return await Columns.Get( "AdsPublications", getDefault() );
}

// function GetMapping(): Dictionary<string> {
//     return { ...Fields.GetMapping() };
// }

async function Toggle( existingColumn: Column ): Promise<CustomError | undefined> {
    return await Columns.Toggle( "AdsPublications", existingColumn, getDefault() );
}

export default {
    GetDefaultSort,
    Get,
    // GetMapping,
    Toggle
};
